<template>
    <div class="dashboard-wrapper pb-1 mb-3">
        <div class="pt-2 pb-2">
            <i class="fa fa-calendar-check-o dark-blue" aria-hidden="true"></i>
            <span class="dark-blue font-weight-bold ml-1">
                {{ $t('daily.initiatives') }}
                <i
                    v-b-tooltip.hover
                    class="fa fa-question-circle icon-help ml-1"
                    aria-hidden="true"
                    :title="$t('statusInfoMessage')"
                ></i
            ></span>
        </div>
        <b-row class="mb-2">
            <b-col class="col">
                <div class="border-div border-total d-flex flex-column">
                    <span>Total</span>
                    <span class="font-weight-bold">{{ totalInitiatives }}</span>
                </div>
            </b-col>
            <b-col class="col">
                <div class="border-div border-todo">
                    <b-form-checkbox
                        id="daily-show-initiative-todo"
                        v-model="selected"
                        value="todo"
                        name="daily-show-initiative-todo"
                    >
                        {{ $t('daily.statusType.notStarted') }}
                    </b-form-checkbox>
                    <span class="font-weight-bold" v-if="todoTotal || todoTotal == 0">
                        {{ todoTotal }} ({{ getPercentage(todoTotal) }}%)
                    </span>
                    <span class="font-weight-bold" v-else>-</span>
                </div>
            </b-col>
            <b-col class="col">
                <div class="border-div border-doing">
                    <b-form-checkbox
                        id="daily-show-initiative-doing"
                        v-model="selected"
                        value="doing"
                        name="daily-show-initiative-doing"
                    >
                        {{ $t('daily.statusType.inProgress') }}
                    </b-form-checkbox>
                    <span class="font-weight-bold" v-if="doingTotal || doingTotal == 0">
                        {{ doingTotal }} ({{ getPercentage(doingTotal) }}%)
                    </span>
                    <span class="font-weight-bold" v-else>-</span>
                </div>
            </b-col>
            <b-col class="col">
                <div class="border-div border-done">
                    <b-form-checkbox
                        id="daily-show-initiative-done"
                        v-model="selected"
                        value="done"
                        name="daily-show-initiative-done"
                    >
                        {{ $t('daily.statusType.completed') }}
                    </b-form-checkbox>
                    <span class="font-weight-bold" v-if="doneTotal || doneTotal == 0">
                        {{ doneTotal }} ({{ getPercentage(doneTotal) }}%)
                    </span>
                    <span class="font-weight-bold" v-else>-</span>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
    name: 'InitiativeDashboard',
    methods: {
        ...mapMutations({
            setSelected: 'daily/SET_selected',
        }),
        getPercentage(value) {
            const percentage = ((value / this.totalInitiatives) * 100).toFixed(0)
            return isNaN(percentage) ? null : percentage
        },
    },
    computed: {
        ...mapGetters('daily', ['todoTotal', 'doingTotal', 'doneTotal']),
        totalInitiatives() {
            return this.todoTotal + this.doingTotal + this.doneTotal
        },
        selected: {
            get() {
                return this.$store.state.daily.selected
            },
            set(value) {
                this.setSelected(value)
            },
        },
    },
    i18n: {
        messages: {
            'en-US': {
                statusInfoMessage: '% of initiatives related to the selected status',
            },
            'es-ES': {
                statusInfoMessage: '% de iniciativas relacionadas con el estado seleccionado',
            },
            'pt-BR': {
                statusInfoMessage: '% de iniciativas relativas ao status selecionado',
            },
        },
    },
}
</script>

<style scoped>
.border-div {
    height: 50px !important;
    padding-left: 0.5rem !important;
    border-left: 4px solid;
}
.border-todo {
    border-color: #f86c6b !important;
}
.border-doing {
    border-color: #ffc107 !important;
}
.border-done {
    border-color: #4dbd74 !important;
}
.border-total {
    border-color: #ccebf8 !important;
}
.dashboard-wrapper {
    max-width: 45vw;
    font-size: 1.1em;
}

@media screen and (max-width: 1440px) {
    .dashboard-wrapper {
        max-width: 55vw;
    }
}
.icon-help {
    color: #bec0c0;
}
</style>
